import { render, staticRenderFns } from "./FormPWR4.vue?vue&type=template&id=67647c2c&scoped=true"
import script from "./FormPWR4.vue?vue&type=script&lang=js"
export * from "./FormPWR4.vue?vue&type=script&lang=js"
import style0 from "./FormPWR4.vue?vue&type=style&index=0&id=67647c2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67647c2c",
  null
  
)

export default component.exports